import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap'

export class FormModal extends Component {
    render() {
        return <Modal show={this.props.show} onHide={this.props.onHide}>
            {this.props.title !== undefined
                ? <Modal.Header closeButton>
                    <Modal.Title>{this.props.title}</Modal.Title>
                </Modal.Header>
                : null}
            <Modal.Body>
                {this.props.children}
            </Modal.Body>
            <Modal.Footer>
                {this.props.onSubmit !== undefined && this.props.actionTitle !== undefined
                    ? <Button onClick={this.props.onSubmit}>{this.props.actionTitle}</Button>
                    : null}
                <Button onClick={this.props.onHide}>{this.props.cancelTitle}</Button>
            </Modal.Footer>
        </Modal>
    }
}




// WEBPACK FOOTER //
// ./src/components/FormModal.js